<!-- LOGO -->
@if (tucieloAquaLogoShow || showHoaLogo) {
  <a
    class="logo-link"
    [attr.href]="logoUrl"
    [class]="{ large: largeDesktopLogo, medium: tabletLogo }"
    >
    <!-- [attr.href] is needed instead of [href], because [href] doesn't disable the link when `null` or `undefined` is passed -->
    <img
      src="/assets/images/Tucielo Logo.png"
      class="logo"
      [ngClass]="{ hoaLogo: tucieloAquaLogoShow || showHoaLogo }"
      />
  </a>
}
@if (showLogo && !tucieloAquaLogoShow && !showHoaLogo) {
  <a
    class="logo-link"
    [attr.href]="logoUrl"
    [class]="{ large: largeDesktopLogo, medium: tabletLogo }"
    >
    <!-- [attr.href] is needed instead of [href], because [href] doesn't disable the link when `null` or `undefined` is passed -->
    <img src="/assets/images/ygrene-logo-black-large.svg" class="logo" />
  </a>
}

<ng-content select="[customHeader]"></ng-content>

<!-- ACTION ICONS -->
<ng-container *transloco="let t; prefix: 'designSystem'">
  <div class="button-group">
    @if (showLanguageToggler) {
      <button
        mat-button
        [matMenuTriggerFor]="languageMenu"
        [matTooltip]="t('language')"
        class="header-button language-toggler"
        [class.active]="language.menuOpen"
        #language="matMenuTrigger"
        >
        <fa-icon [icon]="['fas', 'globe-americas']"></fa-icon>
        <span>{{ currentLanguage }}</span>
      </button>
    }
    @if (showPaceGuidelines) {
      @if (showPaceGuidelinesWithText) {
        <button
          mat-button
          [matMenuTriggerFor]="paceGuidelinesMenu"
          class="header-button pace-guidelines"
          [class.active]="paceGuidelines.menuOpen"
          #paceGuidelines="matMenuTrigger"
          [matTooltip]="t('paceQuestions')"
          matTooltipClass="offset-down"
          >
          <fa-icon [icon]="['fas', 'book-reader']"></fa-icon>
          <span>{{ t('paceQuestions') }}</span>
        </button>
      }
      @if ((isNotMobile$ | ngrxPush) && !showPaceGuidelinesWithText && !isMiniApp) {
        <button
          mat-icon-button
          [matMenuTriggerFor]="paceGuidelinesMenu"
          class="header-icon"
          [class.active]="paceGuidelines.menuOpen"
          #paceGuidelines="matMenuTrigger"
          [matTooltip]="t('paceQuestions')"
          matTooltipClass="offset-down"
          >
          <div class="hover-effect"></div>
          <fa-icon [icon]="['fas', 'book-reader']"></fa-icon>
        </button>
      }
      <!-- mini app required label as well and so mat-button have to used -->
      @if ((isNotMobile$ | ngrxPush) && !showPaceGuidelinesWithText && isMiniApp) {
        <button
          mat-button
          class="mini-app-question-btn"
          [matMenuTriggerFor]="paceGuidelinesMenu"
          [class.active]="paceGuidelines.menuOpen"
          #paceGuidelines="matMenuTrigger"
          [matTooltip]="t('paceQuestions')"
          matTooltipClass="offset-down"
          >
          <div class="hover-effect"></div>
          <fa-icon [icon]="['fas', 'book-reader']"></fa-icon>
          <span class="question-text">{{ t('paceQuestions') }}</span>
        </button>
      }
    }

    @if (!hidePhone && !userTypeContractor && !isMiniApp) {
      <button
        class="header-icon"
        [matTooltip]="t('phone')"
        matTooltipClass="offset-down"
        >
        <div class="hover-effect"></div>
        <a [href]="!tucieloAquaLogoShow && !showHoaLogo ? 'tel:866-634-1358' : 'tel:866-950-7874'">
          <fa-icon [icon]="['fas', 'phone']"></fa-icon>
        </a>
      </button>
    }
    @if (showMoreAction && !userTypeContractor && !isMiniApp) {
      <button
        class="header-icon"
        [matTooltip]="t('moreActions')"
        matTooltipClass="offset-down"
        [matMenuTriggerFor]="moreActionsMenu"
        >
        <div class="hover-effect"></div>
        <fa-icon [icon]="['fas', 'ellipsis-v']"></fa-icon>
      </button>
    }
    <!-- ellipsis will shown for mini app only in mobile -->
    @if (isMiniApp && !userTypeContractor && isMobile$ | ngrxPush) {
      <button
        class="header-icon"
        [matTooltip]="t('moreActions')"
        matTooltipClass="offset-down"
        [matMenuTriggerFor]="moreActionsMenu"
        >
        <div class="hover-effect"></div>
        <fa-icon [icon]="['fas', 'ellipsis-v']"></fa-icon>
      </button>
    }
  </div>

  <!-- EXPANDABLE CONTENT CONTAINER -->
  @if (showContent) {
    <div class="content-container" @rollUp>
      <div class="animation-container"><ng-content></ng-content></div>
    </div>
  }

  <!-- Pace Guidelines Expandable Menu -->
  <mat-menu
    #paceGuidelinesMenu
    class="pace-guidelines-menu"
    backdropClass="cdk-overlay-backdrop-pace-guidelines-menu"
    >
    <p>
      {{ t('guidelinesDescription') }}
    </p>
    <p>
      {{ t('downloadText') }}
      @if (showSpanishDocuments) {
        {{ t('paceGuidelines') }}
        <a target="_blank" [href]="programGuidelinesUrl.english" class="link">
          {{ t('english') }}</a
          >
          {{ t('or') }}
          <a target="_blank" [href]="programGuidelinesUrl.spanish" class="link">Español</a>.
        } @else {
          <a target="_blank" [href]="programGuidelinesUrl.english" class="link">{{
            t('paceGuidelines')
          }}</a>
        }
      </p>
      <button mat-button>{{ t('gotIt') }}</button>
    </mat-menu>

    <!-- Language Expandable Menu -->
    <mat-menu #languageMenu class="language-menu">
      <button
        mat-button
        [class.active]="currentLanguage === Language.English"
        (click)="onLanguageChange(Language.English)"
        >
        English
      </button>
      <button
        mat-button
        [class.active]="currentLanguage === Language.Espanol"
        (click)="onLanguageChange(Language.Espanol)"
        >
        Español
      </button>
    </mat-menu>

    <!-- DROPDOWN MENU -->
    <mat-menu class="more-actions-menu" #moreActionsMenu [overlapTrigger]="true" xPosition="before">
      @if ((isMobile$ | ngrxPush) && showPaceGuidelines && !showPaceGuidelinesWithText) {
        <a
          mat-menu-item
          [matMenuTriggerFor]="paceGuidelinesMenu"
          #paceGuidelines="matMenuTrigger"
          [matTooltip]="t('paceQuestions')"
          matTooltipClass="offset-down"
          >
          <fa-icon [icon]="['fas', 'book-reader']"></fa-icon>
          <span>{{ t('paceQuestions') }}</span>
        </a>
      }
      @if (!hidePortal && !isMiniApp) {
        <a
          [href]="loginUrl"
          target="_blank"
          rel="noopener"
          mat-menu-item
          [matTooltip]="t('ownerPortalLoginTooltip')"
          matTooltipPosition="right"
          matTooltipShowDelay="400"
          >
          <fa-icon [icon]="['fas', 'sign-in']"></fa-icon>
          <span>{{ t('homeOwnerPortalLabel') }}</span>
        </a>
      }
      @if (!isMiniApp) {
        <a
          [href]="t('privacyPolicyLink')"
          target="_blank"
          rel="noopener"
          mat-menu-item
          [matTooltip]="t('privacyPolicyTooltip')"
          matTooltipPosition="right"
          matTooltipShowDelay="400"
          >
          <fa-icon [icon]="['fas', 'balance-scale-right']"></fa-icon>
          <span>{{ t('privacyPolicyLabel') }}</span>
        </a>
      }
      @if (!isMiniApp) {
        <a
          [href]="t('termsLink')"
          target="_blank"
          rel="noopener"
          mat-menu-item
          [matTooltip]="t('termsOfUseTooltip')"
          matTooltipPosition="right"
          matTooltipShowDelay="400"
          >
          <fa-icon [icon]="['far', 'file-alt']"></fa-icon>
          <span>{{ t('termsOfUseLabel') }}</span>
        </a>
      }
      <mat-divider></mat-divider>
      <div class="dbo-disclosure">
        <p>
          <fa-icon [icon]="['fas', 'copyright']"></fa-icon>
          {{ t('ygrene') }}
        </p>
        <p>{{ t('dboDisclosure') }}</p>
      </div>
    </mat-menu>
  </ng-container>
